import { axios } from '@Root/API'

export const edit = (studyProgrammeId, moduleInstanceId, payload) => {
	return axios.post(`course-session/${studyProgrammeId}/module-instances/${moduleInstanceId}`, payload)
}
